import React from "react"
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'

import style from './index.module.scss';
import formImg from "../../content/assets/form-1200-600.png"
import moneyImg from "../../content/assets/money-1200-600.png"
import podiumImg from "../../content/assets/podium-1200-600.png"

class Index extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Index" />
        <div className={style.headerDiv}>
          <h2>USE AI, DATA AND COMMUNITY TO BREAK THE POLITICAL MACHINE</h2>
          <hr/>
          <h3>Learn about the influence of big money on laws and politics</h3>
          <div className={style.gridContainer}>
            <div className={`${style.gridItem} ${style.item1}`}>
              <img src={formImg} className={style.gridImg} />
            </div>
            <div className={`${style.gridItem} ${style.item2}`}>
              <h3>INVESTIGATE FINANCIAL TIES TO FIND POWERFUL GROUPS</h3>
You will be able to research the financial connections between your representatives and PACs. Use AI as a tool to help you in your investigation.
            </div>
            <div className={`${style.gridItem} ${style.item3}`}>
              <img src={moneyImg} className={style.gridImg} />
            </div>
            <div className={`${style.gridItem} ${style.item4}`}>
              <h3>FIND OUT HOW THE MONEY YOU GAVE IS USED BY THE CAMPAIGN</h3>
See top level services and items used by campaigns or even PACs in relation to a candidate or legislation
            </div>
            <div className={`${style.gridItem} ${style.item5}`}>
              <img src={podiumImg} className={style.gridImg} />
            </div>
            <div className={`${style.gridItem} ${style.item6}`}>
              <h3>GET UPDATES ON BIG MONEY AND THEIR POLITICIANS</h3>
 Sign-up to be alerted of new patterns special Interests and opaque donor organizations are starting to engage in to sway politics.
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Index


export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
